/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Switch, Route, Redirect } from 'react-router-dom';

import Auth from 'auth/Auth';
import LoginPage from 'components/login/LoginPage';
import MainWrapper from 'components/wrapper/MainWrapper';
import SetPassword from './components/login/SetPassword';

const auth = new Auth();
// eslint-disable-next-line react/prop-types
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={
      props =>
        auth.isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login' }} />
        )
      // eslint-disable-next-line react/jsx-curly-newline
    }
  />
);

const RouterComponent = () => (
  <Switch>
    <Route
      exact
      path="/login"
      component={props => <LoginPage type="login" {...props} />}
    />
    <Route
      exact
      path="/reset-password"
      component={props => <LoginPage type="reset" {...props} />}
    />
    <Route path="/set-password/:uidb64/:token" component={SetPassword} />

    <PrivateRoute path="/" component={MainWrapper} />
  </Switch>
);

export default RouterComponent;
